import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datePickerLang'
})
export class DatePickerLangPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
